export const state = {
  home: [{
    text: "bread_crumb.home",
    to: "/"
  },
  {
    text: "Dashboard",
    active: true
  }
  ],
  employee: {
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.employee.name",
      to: "/employees"
    },
    {
      text: "bread_crumb.employee.list",
      active: true
    }
    ],
    create: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.employee.name",
      to: "/employees"
    },
    {
      text: "bread_crumb.employee.create",
      active: true
    }
    ],
    detail: [{
      text: "bread_crumb.home",
      t0: "/"
    },
    {
      text: "bread_crumb.employee.name",
      to: "/employees"
    },
    {
      text: "bread_crumb.employee.detail",
      active: true
    }
    ],
    update: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.employee.name",
      to: "/employees"
    },
    {
      text: "bread_crumb.employee.update",
      active: true
    }
    ],
    resign: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.employee.name",
      to: "/employees"
    },
    {
      text: "bread_crumb.employee.resign",
      active: true
    }
    ],
    level: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.employee.name",
      to: "/employees"
    },
    {
      text: "bread_crumb.employee.level",
      active: true
    }
    ]
  },
  customer: {
    create: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.customer.name",
      to: "/customers"
    },
    {
      text: "bread_crumb.customer.create",
      active: true
    }
    ],
    update: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.customer.name",
      to: "/customers"
    },
    {
      text: "bread_crumb.customer.update",
      active: true
    }
    ],
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.customer.name",
      to: "/customers"
    },
    {
      text: "bread_crumb.customer.list",
      active: true
    }
    ],
    detail: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.customer.name",
      to: "/customers"
    },
    {
      text: "bread_crumb.customer.detail",
      active: true
    }
    ]
  },
  project: {
    create: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.project.name",
      to: "/project-overview"
    },
    {
      text: "bread_crumb.project.create",
      active: true
    }
    ],
    update: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.project.name",
      to: "/project-overview"
    },
    {
      text: "bread_crumb.project.update",
      active: true
    }
    ],
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.project.name",
      to: "/project-overview"
    },
    {
      text: "bread_crumb.project.list",
      active: true
    }
    ],
    resource: [{
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project.name",
        to: "/project-overview"
      },
      {
        text: "bread_crumb.project.resource",
        active: true
      }
    ],
    detail: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.project.name",
      to: "/project-overview"
    },
    {
      text: "bread_crumb.project.detail",
      active: true
    }
    ],
    edit: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project.name",
        to: "/project-overview"
      },
      {
        text: "bread_crumb.project.edit",
        active: true
      }
    ],
    effort: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project.name",
        to: "/project-overview"
      },
      {
        text: "bread_crumb.project.effort",
      }
    ],
    review: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project.name",
        to: "/project-overview"
      },
      {
        text: "bread_crumb.project.review",
      }
    ],
    activities: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project.name",
        to: "/project-overview"
      },
      {
        text: "bread_crumb.project.activities",
      }
    ],
    contract: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project.name",
        to: "/project-overview"
      },
      {
        text: "bread_crumb.project.contract",
        active: true
      }
    ],
  },
  resource: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.project.name",
      to: "/project-overview"
    },
    {
      text: "bread_crumb.project.resource",
      to: "/projects/resource-situation/resource-overview"
    },
    {
      text: "bread_crumb.resource.info"
    }
  ],
  timesheet: {
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.timesheet.name",
      to: "/timesheets"
    },
    {
      text: "bread_crumb.timesheet.list",
      active: true
    }
    ],
    import: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.timesheet.name",
      to: "/timesheets"
    },
    {
      text: "bread_crumb.timesheet.import",
      active: true
    }
    ],
    summary: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.timesheet.name",
      to: "/timesheets"
    },
    {
      text: "bread_crumb.timesheet.summary",
      active: true
    }
    ],
    list_submit: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.timesheet.name",
      to: "/timesheets"
    },
    {
      text: "bread_crumb.timesheet.list_submit_timesheet",
      active: true
    }
    ],
    remind_history: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.timesheet.name",
      to: "/timesheets"
    },
    {
      text: "bread_crumb.timesheet.list_submit_timesheet",
      active: true
    }
    ],
    employee_timesheet_detail: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.timesheet.name",
      to: "/timesheets"
    },
    {
      text: "bread_crumb.timesheet.employee_timesheet_detail",
      active: true
    }
    ],
  },
  overtime: {
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.overtime.name",
      to: "/overtime-requests"
    },
    {
      text: "bread_crumb.overtime.list",
      active: true
    }
    ],
    detail: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.overtime.name",
      to: "/overtime-requests"
    },
    {
      text: "bread_crumb.overtime.detail",
      active: true
    }
    ]
  },
  remote: {
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.remote.name",
      to: "/remote-requests"
    },
    {
      text: "bread_crumb.remote.list",
      active: true
    }
    ],
    detail: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.remote.name",
      to: "/remote-requests"
    },
    {
      text: "bread_crumb.remote.detail",
      active: true
    }
    ]
  },
  sabbatical: {
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.sabbatical.name",
      to: "/sabbatical-leave-requests"
    },
    {
      text: "bread_crumb.sabbatical.list",
      active: true
    }
    ],
    detail: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.sabbatical.name",
      to: "/sabbatical-leave-requests"
    },
    {
      text: "bread_crumb.sabbatical.detail",
      active: true
    }
    ]
  },
  shortLeaveRequest: {
    list: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.short_leave_request.name",
        to: "/short-leave-requests"
      },
      {
        text: "bread_crumb.short_leave_request.list",
        active: true
      }
    ]
  },
  account: {
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.account.name",
      to: "/accounts"
    },
    {
      text: "bread_crumb.account.list",
      active: true
    }
    ]
  },
  additional_timesheet: {
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.additional_timesheet.name",
      to: "/additional-timesheet"
    },
    {
      text: "bread_crumb.additional_timesheet.list",
      active: true
    }
    ],
    detail: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.additional_timesheet.name",
      to: "/additional-timesheet"
    },
    {
      text: "bread_crumb.additional_timesheet.detail",
      active: true
    }
    ]
  },
  contract: {
    create: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.contract.name",
      to: "/contracts"
    },
    {
      text: "bread_crumb.contract.create",
      active: true
    }
    ],
    update: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.contract.name",
      to: "/contracts"
    },
    {
      text: "bread_crumb.contract.update",
      active: true
    }
    ],
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.contract.name",
      to: "/contracts"
    },
    {
      text: "bread_crumb.contract.list",
      active: true
    }
    ]
  },
  skill: {
    create: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.skill.name",
      to: "/skill"
    },
    {
      text: "bread_crumb.skill.create",
      active: true
    }
    ],
    update: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.skill.name",
      to: "/skill"
    },
    {
      text: "bread_crumb.skill.update",
      active: true
    }
    ],
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.skill.name",
      to: "/skill"
    },
    {
      text: "bread_crumb.skill.list",
      active: true
    }
    ],
    detail: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.skill.name",
      to: "/skill"
    },
    {
      text: "bread_crumb.skill.detail",
      active: true
    }
    ]
  },
  seat_employee: {
    seat: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.seat.name",
      to: "seating-chart"
    }
    ],
  },
  type_work: {
    type: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.type_work.name",
      to: "type-work"
    }
    ],
  },
  compensate: {
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.compensate.name",
      to: "/sabbatical-compensate"
    },
    {
      text: "bread_crumb.compensate.list",
      active: true
    }
    ],
    detail: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.compensate.name",
      to: "/sabbatical-compensate"
    },
    {
      text: "bread_crumb.compensate.detail",
      active: true
    }
    ]
  },
  holiday_setting: {
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "holiday_setting.title",
      active: true
    }
    ]
  },
  timesheet_submit_period: {
    show: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "timesheet_submit_period.title",
      active: true
    }
    ]
  },
  sabbatical_adjustment: {
    list: [{
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "sabbatical_adjustment.title",
      active: true
    }
    ]
  }
}

// getters
export const getters = {
  home: state => state.home,
  employeeList: state => state.employee.list,
  employeeCreate: state => state.employee.create,
  employeeDetail: state => state.employee.detail,
  employeeUpdate: state => state.employee.update,
  employeeResign: state => state.employee.resign,
  employeeLevel: state => state.employee.level,
  holidaySettingList: state => state.holiday_setting.list,
  timesheetSubmitPeriod: state => state.timesheet_submit_period.show,
  sabbaticalAdjustment: state => state.sabbatical_adjustment.list,
  customerCreate: state => state.customer.create,
  customerUpdate: state => state.customer.update,
  customerList: state => state.customer.list,
  customerDetail: state => state.customer.detail,
  projectCreate: state => state.project.create,
  projectUpdate: state => state.project.update,
  projectList: state => state.project.list,
  projectResource: state => state.project.resource,
  resource: state => state.resource,
  projectDetail: state => state.project.detail,
  projectEdit: state => state.project.edit,
  projectManagementEffort: state => state.project.effort,
  projectManagementReview: state => state.project.review,
  projectManagementActivities: state => state.project.activities,
  projectContract: state => state.project.contract,
  timesheetList: state => state.timesheet.list,
  timesheetImport: state => state.timesheet.import,
  timesheetSummary: state => state.timesheet.summary,
  timesheetListSubmit: state => state.timesheet.list_submit,
  remindHistory: state => state.timesheet.remind_history,
  employeeTimesheetDetail: state => state.timesheet.employee_timesheet_detail,
  overtimeList: state => state.overtime.list,
  overtimeDetail: state => state.overtime.detail,
  remoteList: state => state.remote.list,
  remoteDetail: state => state.remote.detail,
  sabbaticalList: state => state.sabbatical.list,
  sabbaticalDetail: state => state.sabbatical.detail,
  accountList: state => state.account.list,
  additionalTimeSheetList: state => state.additional_timesheet.list,
  additionalTimeSheetDetail: state => state.additional_timesheet.detail,
  contractCreate: state => state.contract.create,
  contractUpdate: state => state.contract.update,
  contractList: state => state.contract.list,
  skillList: state => state.skill.list,
  compensateList: state => state.compensate.list,
  compensateDetail: state => state.compensate.detail,
  seat: state => state.seat_employee.seat,
  typeWork: state => state.type_work.type
}
